import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { unitStats } from '../../../stats';

export const councilReducer = (scratch: StatsSnapshot) => {
  const stats = unitStats.council;
  const generatedGarrisons = stats.buildingsGeneration ?? 0;

  scratch.generators.garrison.owned += generatedGarrisons;

  return;
};
